"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wizard = void 0;
var React = require("react");
var Timeline_1 = require("../Timeline");
var Button_1 = require("../Button");
var styled_1 = require("../../styled");
var theme_1 = require("../../theme");
var NotificationBar_1 = require("../NotificationBar");
var Wizard = /** @class */ (function (_super) {
    __extends(Wizard, _super);
    function Wizard(props) {
        var _this = _super.call(this, props) || this;
        _this.onBackClicked = function () {
            var activeStepIndex = _this.state.activeStepIndex;
            var notOnFirstStep = activeStepIndex > 0;
            if (typeof _this.props.onBackClicked === 'function' && notOnFirstStep) {
                _this.props.onBackClicked({
                    activeStepIndex: activeStepIndex
                });
            }
            if (notOnFirstStep) {
                _this.setState({ activeStepIndex: activeStepIndex - 1 });
            }
        };
        _this.onNextClicked = function () {
            var _a = _this.props, steps = _a.steps, onCompleted = _a.onCompleted, onNextClicked = _a.onNextClicked;
            var activeStepIndex = _this.state.activeStepIndex;
            var validate = steps[activeStepIndex].validate || undefined;
            var newStepIndex = activeStepIndex + 1;
            var isOnLastStep = activeStepIndex === steps.length - 1;
            var validationErrors = [];
            if (typeof validate === 'function') {
                validationErrors = validate();
                if (validationErrors.length > 0) {
                    _this.setState({ validationErrors: validationErrors });
                    return;
                }
            }
            if (typeof onNextClicked === 'function' && !isOnLastStep) {
                onNextClicked({
                    activeStepIndex: activeStepIndex
                });
            }
            if (isOnLastStep) {
                onCompleted();
            }
            else {
                _this.setState({ activeStepIndex: newStepIndex, validationErrors: [] });
            }
        };
        _this.renderButtons = function () {
            var activeStepIndex = _this.state.activeStepIndex;
            var _a = _this.props, steps = _a.steps, _b = _a.prevButtonText, prevButtonText = _b === void 0 ? 'Back' : _b, _c = _a.cancelButtonText, cancelButtonText = _c === void 0 ? 'Cancel' : _c, _d = _a.nextButtonText, nextButtonText = _d === void 0 ? 'Next' : _d, _e = _a.completeButtonText, completeButtonText = _e === void 0 ? 'Save' : _e, onCancel = _a.onCancel, _f = _a.style, style = _f === void 0 ? {} : _f, _g = _a.hideBackButton, hideBackButton = _g === void 0 ? false : _g;
            var isOnLastStep = activeStepIndex === steps.length - 1;
            var isOnFirstStep = activeStepIndex === 0;
            return (React.createElement(WizardFooter, { style: __assign(__assign({}, style.footer), (hideBackButton && { justifyContent: 'center' })) },
                !hideBackButton && (React.createElement("div", null,
                    React.createElement(Button_1.Button, { onClick: function () {
                            if (isOnFirstStep) {
                                onCancel();
                            }
                            else {
                                _this.onBackClicked();
                            }
                        } }, isOnFirstStep ? cancelButtonText : prevButtonText))),
                React.createElement("div", { style: { paddingLeft: theme_1.spacing.mini } },
                    React.createElement(Button_1.Button, { variant: "primary", onClick: _this.onNextClicked, disabled: _this.disableNext() }, isOnLastStep ? completeButtonText : nextButtonText))));
        };
        _this.disableNext = function () {
            var disableNext = _this.props.disableNext;
            if (typeof disableNext !== 'function') {
                return false;
            }
            return disableNext(_this.state);
        };
        _this.state = {
            activeStepIndex: props.startingIndex || 0,
            validationErrors: []
        };
        return _this;
    }
    Wizard.prototype.render = function () {
        var _a = this.props, steps = _a.steps, _b = _a.hideTimeline, hideTimeline = _b === void 0 ? false : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
        var _d = this.state, activeStepIndex = _d.activeStepIndex, validationErrors = _d.validationErrors;
        var activeStep = steps[activeStepIndex];
        return (React.createElement(WizardWrapper, { style: style.wrapper },
            !hideTimeline && (React.createElement(WizardHeader, null,
                React.createElement(TimelineWrapper, null,
                    React.createElement(Timeline_1.Timeline, { stepBaseIndex: 0, wrapperWidth: "100%", activeStep: activeStepIndex, steps: steps.map(function (s) { return ({
                            title: s.title,
                            subtitle: s.subtitle || ''
                        }); }) })))),
            React.createElement(WizardContent, null,
                React.createElement(ValidationWrapper, null, validationErrors.length > 0 && (React.createElement(NotificationBar_1.Notification, { variant: "error", icon: "warning" },
                    React.createElement(ValidationErrors, null, validationErrors.map(function (error) { return (React.createElement("li", { key: error }, error)); }))))),
                /* User render function if supplied, otherwise try to render the step's component */
                typeof activeStep.render === 'function'
                    ? activeStep.render()
                    : activeStep.component || null),
            this.renderButtons()));
    };
    return Wizard;
}(React.Component));
exports.Wizard = Wizard;
var WizardWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  border: 1px solid ", ";\n  border-radius: 0.333rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  border: 1px solid ", ";\n  border-radius: 0.333rem;\n"])), theme_1.colors.black05);
var WizardHeader = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  background: ", ";\n  justify-content: center;\n  padding: 1rem;\n"], ["\n  display: flex;\n  background: ", ";\n  justify-content: center;\n  padding: 1rem;\n"])), theme_1.colors.black05);
var TimelineWrapper = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var WizardContent = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  min-height: 16.667rem;\n"], ["\n  min-height: 16.667rem;\n"])));
var WizardFooter = styled_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  background: ", ";\n  padding: 1rem;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  background: ", ";\n  padding: 1rem;\n  justify-content: space-between;\n"])), theme_1.colors.black05);
var ValidationWrapper = styled_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin: 1rem;\n"], ["\n  margin: 1rem;\n"])));
var ValidationErrors = styled_1.default.ul(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"], ["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=index.js.map